import { Button } from '@design-system/button';
import { Typography } from '@design-system/typography';
import { useProfile } from '@phx-husky/use-profile';
import { useTranslations } from '@phx-husky/use-translations';
import classNames from 'classnames';
import React, { useState } from 'react';

import { Form } from '../form';
import { DeleteAccountProps } from '../models';
import * as sectionStyles from './security-section.module.scss';

export const DeleteAccount = ({
  fields,
  editButtonDisabled,
  onAccountDelete,
  onFormCloseCallback,
}: DeleteAccountProps) => {
  const [formVisible, setFormVisible] = useState(false);
  const { deleteCurrentUser, isPasswordProviderUser } = useProfile();
  const { translate } = useTranslations();

  const onSubmit = async (params: { loginPassword: string }) => {
    const result = await deleteCurrentUser({
      password: params.loginPassword as string,
    });
    if (result.success) {
      onAccountDelete?.();
    }

    return result;
  };

  const onClose: DeleteAccountProps['onFormCloseCallback'] = (params) => {
    setFormVisible(false);
    onFormCloseCallback(params);
  };

  return (
    <div className={classNames(sectionStyles.section)}>
      <Typography
        variant="headline"
        className={sectionStyles.title}
        content={translate('securityDeleteTitle')}
      />
      <Typography
        variant="body"
        className={sectionStyles.description}
        content={translate('securityDeleteDescription')}
      />
      {formVisible ? (
        <Form
          fields={
            isPasswordProviderUser()
              ? fields
              : { deleteAccountStatement: fields.deleteAccountStatement }
          }
          onSubmit={onSubmit}
          onClose={onClose}
          cancelButtonLabel={translate('securityDeleteAccountCancelButton')}
          submitButtonLabel={translate('securityDeleteAccountSubmitButton')}
        />
      ) : (
        <Button
          variant="secondary"
          size="large"
          className={(sectionStyles.buttonIcon, 'delete-account')}
          iconPrefix={{ props: { icon: 'close', size: '20px' } }}
          type="button"
          onClick={() => setFormVisible(true)}
          disabled={editButtonDisabled}
        >
          {translate('securityDeleteAccountSubmitButton')}
        </Button>
      )}
    </div>
  );
};
